"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageLoader = imageLoader;
/**
 * Custom Next.js image loader for static exports
 * Returns the source as-is since we're using static optimization
 */
function imageLoader({ src, width, quality }) {
    return src;
}
exports.default = imageLoader;
